var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4858 2.00562L9.86438 6.18076L10.9039 3.71748L15.4858 2.00562Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5085 2.00562L8.08477 6.2203L7.09607 3.71748L2.5085 2.00562ZM13.4633 11.6836L11.9661 13.9774L15.1695 14.8587L16.0904 11.7344L13.4633 11.6836ZM1.91528 11.7344L2.83054 14.8587L6.03393 13.9774L4.53675 11.6836L1.91528 11.7344Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8531 7.8079L4.96045 9.15818L8.14124 9.29942L8.02825 5.88134L5.8531 7.8079ZM12.1412 7.8079L9.93785 5.8418L9.8644 9.29942L13.0395 9.15818L12.1412 7.8079ZM6.0339 13.9774L7.9435 13.0452L6.29378 11.7571L6.0339 13.9774ZM10.0508 13.0452L11.9661 13.9774L11.7006 11.7571L10.0508 13.0452Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9661 13.9774L10.0508 13.0452L10.2034 14.2938L10.1864 14.8192L11.9661 13.9774ZM6.03387 13.9774L7.81354 14.8192L7.80224 14.2938L7.94348 13.0452L6.03387 13.9774Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84182 10.9321L6.2486 10.4632L7.37289 9.9491L7.84182 10.9321ZM10.1526 10.9321L10.6215 9.9491L11.7514 10.4632L10.1526 10.9321Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03392 13.9774L6.3051 11.6836L4.53674 11.7345L6.03392 13.9774ZM11.6949 11.6836L11.9661 13.9774L13.4633 11.7345L11.6949 11.6836ZM13.0396 9.1582L9.86443 9.29945L10.1582 10.9322L10.6271 9.94916L11.7571 10.4633L13.0396 9.1582ZM6.24861 10.4633L7.37855 9.94916L7.84183 10.9322L8.14126 9.29945L4.96047 9.1582L6.24861 10.4633Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96045 9.1582L6.29378 11.7571L6.24858 10.4633L4.96045 9.1582ZM11.7571 10.4633L11.7006 11.7571L13.0395 9.1582L11.7571 10.4633ZM8.14124 9.29945L7.84181 10.9322L8.21469 12.8588L8.29943 10.322L8.14124 9.29945ZM9.8644 9.29945L9.71186 10.3164L9.77966 12.8588L10.1582 10.9322L9.8644 9.29945Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1582 10.9322L9.77967 12.8587L10.0509 13.0452L11.7006 11.757L11.7571 10.4633L10.1582 10.9322ZM6.2486 10.4633L6.29379 11.757L7.94351 13.0452L8.2147 12.8587L7.84182 10.9322L6.2486 10.4633Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1864 14.8192L10.2034 14.2938L10.0621 14.1695H7.93218L7.80224 14.2938L7.81354 14.8192L6.03387 13.9774L6.65534 14.4859L7.91523 15.3616H10.0791L11.3446 14.4859L11.9661 13.9774L10.1864 14.8192Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 13.0452L9.77965 12.8588H8.21467L7.94349 13.0452L7.80225 14.2938L7.93219 14.1695H10.0621L10.2034 14.2938L10.0508 13.0452Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7232 6.45194L16.2034 4.14686L15.4859 2.00562L10.0509 6.03951L12.1413 7.80788L15.0961 8.67228L15.7514 7.90957L15.4689 7.70618L15.9209 7.29375L15.5706 7.02256L16.0226 6.67793L15.7232 6.45194ZM1.79663 4.14686L2.27686 6.45194L1.97177 6.67793L2.42375 7.02256L2.07912 7.29375L2.53109 7.70618L2.24861 7.90957L2.89833 8.67228L5.85313 7.80788L7.94352 6.03951L2.5085 2.00562L1.79663 4.14686Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0961 8.67233L12.1413 7.80792L13.0396 9.15821L11.7006 11.7571L13.4633 11.7345H16.0904L15.0961 8.67233ZM5.85314 7.80792L2.89833 8.67233L1.91528 11.7345H4.53675L6.29381 11.7571L4.96048 9.15821L5.85314 7.80792ZM9.86444 9.29945L10.0509 6.03956L10.9096 3.71753H7.09607L7.94353 6.03956L8.14127 9.29945L8.20907 10.3277L8.21472 12.8588H9.77969L9.79099 10.3277L9.86444 9.29945Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask_icon.2483dca9094cf43d321199744402725e.svg";
export { ForwardRef as ReactComponent };